import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography/Typography";

const styles = (theme) => ({
  error: {
    color: theme.palette.error.main,
    whiteSpace: "pre-line",
    fontSize: 14
  },
});

const ErrorMessage = ({ children, classes, variant }) => {
  return (
    <Typography className={classes.error} variant={variant}>
      {children}
    </Typography>
  );
};
ErrorMessage.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  variant: PropTypes.string,
};
ErrorMessage.defaultProps = {
  variant: "body2",
};

export default withStyles(styles)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/components/UI/ErrorMessage.jsx